import PropTypes from "prop-types";
import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Divider from "@mui/material/Divider";
import moment from "moment-timezone";
import {
  clockInOutColDefs,
  transformClockInOutData,
  clockModeEnum,
  clockInOutColDefsWithEditButtons,
  transformClockInOutDataEditable,
  isPayPeriodClosed,
} from "components/Shared/TimeLogs/Definitions";
import * as yup from "yup";
import { dateTimeToTime } from "components/Shared/Formatters";
import MGrid, { ACTION_ADD, ACTION_DOWNLOAD } from "components/Shared/MGrid.tsx";
import { MSpinner } from "components/Shared";
import MCard from "components/Shared/MCard.tsx";
import { DATA_TYPE_TIME, DATA_TYPE_DATE } from "typeConstants/dataTypes";
class ClockInOutCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clockMode: clockModeEnum.CLOCK_IN,
      addDialogBoxVisible: false,
      clockInValue: "",
      clockOutValue: "",
      deleteRowId: 0,
      deleteDialogBoxVisible: false,
      editRowId: 0,
      editDialogBoxVisible: false,
      addDate: "",
    };
    this.handleClick = this.handleClick.bind(this);
    this.addDialogBox = this.addDialogBox.bind(this);
    this.handleAddConfirm = this.handleAddConfirm.bind(this);
    this.handleAddDisable = this.handleAddDisable.bind(this);
    this.handleEditRow = this.handleEditRow.bind(this);
    this.deleteDialogBox = this.deleteDialogBox.bind(this);
    this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this);
    this.editDialogBox = this.editDialogBox.bind(this);
    this.handleEditConfirm = this.handleEditConfirm.bind(this);
    this.handleDeleteRow = this.handleDeleteRow.bind(this);
    this.setEditCardControls = this.setEditCardControls.bind(this);
    this.setAddCardControls = this.setAddCardControls.bind(this);
    this.validateEditOutValue = this.validateEditOutValue.bind(this);
    this.validateAddOutValue = this.validateAddOutValue.bind(this);
    this.editCardControlMethods = null;
    this.addCardControlMethods = null;
  }
  componentDidUpdate(prevProps) {
    if (prevProps.isFetchingActiveClock && !this.props.isFetchingActiveClock) {
      if (!this.props.activeClock) {
        this.setState({ clockMode: clockModeEnum.CLOCK_IN });
      } else {
        this.setState({ clockMode: clockModeEnum.CLOCK_OUT });
      }
    }

    if (
      (prevProps.isAddingTimeClock && !this.props.isAddingTimeClock) ||
      (prevProps.isDeletingTimeClock && !this.props.isDeletingTimeClock) ||
      (prevProps.isUpdatingTimeClock && !this.props.isUpdatingTimeClock)
    ) {
      this.props.getData(this.props.internetUserId, this.props.payPeriod.id);
      this.props.refreshSummaryCard?.();
    }
    if (
      prevProps.payPeriod.id !== this.props.payPeriod.id ||
      (!this.props.updatingUser && prevProps.updatingUser) ||
      prevProps.internetUserId !== this.props.internetUserId
    ) {
      this.props.getData(this.props.internetUserId, this.props.payPeriod.id);
    }
    if (!this.props.isEditable && !this.props.updatingUser && prevProps.updatingUser) {
      this.props.getActiveClock(new Date().getTimezoneOffset());
    }
  }
  UNSAFE_componentWillMount() {
    this.props.getData(this.props.internetUserId, this.props.payPeriod.id);
    this.props.isEditable ? [] : this.props.getActiveClock(new Date().getTimezoneOffset());
  }
  setEditCardControls(cm) {
    this.editCardControlMethods = cm;
  }
  setAddCardControls(cm) {
    this.addCardControlMethods = cm;
  }
  validateEditOutValue(value) {
    let inTime = this.editCardControlMethods.getEditedData().find((x) => x.key === "clockInDate");
    if (!inTime) {
      inTime = this.state.clockInValue;
    } else {
      inTime = inTime.value;
    }
    let inDateTime = moment(this.state.addDate).format("YYYY-MM-DD") + "T" + inTime;
    let outDateTime = moment(this.state.addDate).format("YYYY-MM-DD") + "T" + value;
    if (moment(outDateTime).diff(moment(inDateTime)) <= 0) {
      return false;
    }
    return true;
  }
  validateAddOutValue(value) {
    let addDate = this.addCardControlMethods.getEditedData().find((x) => x.key === "addDate");
    let inTime = this.addCardControlMethods.getEditedData().find((x) => x.key === "clockInDate");
    if (addDate && inTime) {
      let inDateTime = moment(addDate).format("YYYY-MM-DD") + "T" + inTime.value;
      let outDateTime = moment(addDate).format("YYYY-MM-DD") + "T" + value;
      if (moment(inDateTime).diff(moment(outDateTime)) < 0) {
        return true;
      }
    }
    return false;
  }
  handleClick() {
    let clockMode = this.state.clockMode;
    let timeZoneOffset = new Date().getTimezoneOffset();
    switch (clockMode) {
      case clockModeEnum.CLOCK_IN:
        this.props.clockIn(timeZoneOffset);
        this.setState({ clockMode: clockModeEnum.CLOCK_OUT });
        break;
      case clockModeEnum.CLOCK_OUT:
        this.props.clockOut(timeZoneOffset);
        this.setState({ clockMode: clockModeEnum.CLOCK_IN });
        break;
    }
  }
  addDialogBox() {
    return (
      <div className="clockinout-dialog-box">
        <Dialog open={this.state.addDialogBoxVisible} onClose={() => {}}>
          <DialogContent style={{ padding: 0 }}>
            <MCard
              title="Add Time"
              getControlMethods={this.setAddCardControls}
              fields={[
                {
                  key: "addDate",
                  label: "Date",
                  dataType: DATA_TYPE_DATE,
                  dataTypeOptions: {
                    nullable: false,
                    minDate: this.props.startDate,
                    maxDate: this.props.endDate,
                  },
                  validation: yup.date().typeError("Must be a date").required("Date is a required field"),
                },
                {
                  key: "clockInDate",
                  label: "In",
                  dataType: DATA_TYPE_TIME,
                  validation: yup.string().nullable().required("In is a required field"),
                },
                {
                  key: "clockOutDate",
                  label: "Out",
                  dataType: DATA_TYPE_TIME,
                  validation: yup.string().nullable().required("Out is a required field").test({
                    name: "out>in",
                    message: "Clock out time must be later than Clock in time",
                    test: this.validateAddOutValue,
                  }),
                },
              ]}
              startInEditMode={true}
              isEditable={true}
              onEditCancelled={() => this.setState({ addDialogBoxVisible: false })}
              onEditFinished={(arr, obj) => this.handleAddConfirm(obj)}
            />
          </DialogContent>
        </Dialog>
      </div>
    );
  }
  handleAddConfirm(obj) {
    let dto = {
      clockInDateTime: moment(obj.addDate).format("YYYY-MM-DD") + "T" + obj.clockInDate,
      clockOutDateTime: moment(obj.addDate).format("YYYY-MM-DD") + "T" + obj.clockOutDate,
    };
    this.props.addTimeClock(this.props.internetUserId, dto);
    this.setState({
      addDialogBoxVisible: false,
      addDate: "",
      clockInValue: "",
      clockOutValue: "",
    });
  }
  handleAddDisable() {
    if (!this.state.clockInValue || !this.state.clockOutValue || !this.state.addDate) {
      return true;
    }
    if (
      moment(this.state.addDate + "T" + this.state.clockInValue).diff(
        this.state.addDate + "T" + this.state.clockOutValue,
      ) > 0
    ) {
      return true;
    }
    return false;
  }
  handleEditRow(id) {
    let timeclock = this.props.data.find((x) => x.id === id);
    this.setState({
      addDate: moment(timeclock.clockInDate).format("YYYY-MM-DD"),
      clockInValue: moment(timeclock.clockInDate).format("HH:mm"),
      clockOutValue: moment(timeclock.clockOutDate).format("HH:mm"),
      editRowId: id,
      editDialogBoxVisible: true,
    });
  }
  deleteDialogBox() {
    const actionButtons = [];
    actionButtons.push(
      <Button
        key="cancel"
        variant="text"
        color="secondary"
        onClick={() => this.setState({ deleteDialogBoxVisible: false })}
      >
        Cancel
      </Button>,
    );
    actionButtons.push(
      <Button key="confirm" onClick={this.handleDeleteConfirm}>
        Confirm
      </Button>,
    );
    return (
      <Dialog open={this.state.deleteDialogBoxVisible} onClose={() => this.setState({ deleteDialogBoxVisible: false })}>
        <DialogTitle>Are you sure you want to delete?</DialogTitle>
        <DialogActions>{actionButtons}</DialogActions>
      </Dialog>
    );
  }
  editDialogBox() {
    return (
      <div className="clockinout-dialog-box">
        <Dialog open={this.state.editDialogBoxVisible} onClose={() => {}}>
          <DialogContent style={{ padding: 0 }}>
            <MCard
              title="Edit Time"
              getControlMethods={this.setEditCardControls}
              fields={[
                {
                  key: "clockInDate",
                  label: "In",
                  value: this.state.clockInValue,
                  dataType: DATA_TYPE_TIME,
                  validation: yup.string().nullable().required("In is a required field"),
                },
                {
                  key: "clockOutDate",
                  label: "Out",
                  value: this.state.clockOutValue,
                  dataType: DATA_TYPE_TIME,
                  validation: yup.string().nullable().required("Out is a required field").test({
                    name: "out>in",
                    message: "Clock out time must be later than Clock in time",
                    test: this.validateEditOutValue,
                  }),
                },
              ]}
              startInEditMode={true}
              isEditable={true}
              onEditCancelled={() => this.setState({ editDialogBoxVisible: false })}
              onEditFinished={(arr, obj) => this.handleEditConfirm(obj)}
            />
          </DialogContent>
        </Dialog>
      </div>
    );
  }
  handleDeleteConfirm() {
    this.props.deleteTimeClock(this.state.deleteRowId);
    this.setState({ deleteDialogBoxVisible: false });
  }
  handleEditConfirm(obj) {
    const insertDate = (time) => this.state.addDate + "T" + time;
    const dataRow = this.props.data.find((x) => x.id === this.state.editRowId);
    let timeClock = {
      ...dataRow,
      clockInDate: obj.clockInDate ? insertDate(obj.clockInDate) : dataRow.clockInDate,
      clockOutDate: obj.clockOutDate ? insertDate(obj.clockOutDate) : dataRow.clockOutDate,
    };
    this.props.updateTimeClock(this.state.editRowId, timeClock.clockInDate, timeClock.clockOutDate);
    this.setState({
      addDate: "",
      clockInValue: "",
      clockOutValue: "",
      editDialogBoxVisible: false,
    });
  }
  handleDeleteRow(id) {
    this.setState({ deleteRowId: id, deleteDialogBoxVisible: true });
  }
  render() {
    if (this.props.isFetchingData || this.props.isFetchingActiveClock) {
      return <MSpinner />;
    }
    const activeTime = this.props.activeClock ? dateTimeToTime(this.props.activeClock.clockInDate) : null;
    const cardWithClockInButton = () => {
      return (
        <MCard className="time-clocks" title="Clock In / Out">
          <div style={{ marginTop: 16 }}>
            <Button id="qa-clock-button" style={{ height: 25, marginRight: 10, padding: 0 }} onClick={this.handleClick}>
              {this.state.clockMode}
            </Button>
            {this.state.clockMode === clockModeEnum.CLOCK_OUT && this.props.activeClock ? (
              <div style={{ display: "inline-block" }}>Current Clock In: {activeTime}</div>
            ) : (
              []
            )}
          </div>
          <Divider sx={{ my: 2 }} />
          <MGrid
            columnDefinitions={clockInOutColDefs}
            data={transformClockInOutData(this.props.data)}
            isFetchingData={this.props.isFetchingData}
            displayNumOfItemsFound={false}
          />
        </MCard>
      );
    };

    const editableCardWithoutClockInButton = () => {
      let actions = [];
      if (!isPayPeriodClosed(this.props.payPeriod)) {
        actions.push({
          code: ACTION_ADD,
          onClick: () => this.setState({ addDialogBoxVisible: true }),
        });
      }
      actions.push({ code: ACTION_DOWNLOAD });
      return (
            <MGrid
              columnDefinitions={clockInOutColDefsWithEditButtons}
              data={transformClockInOutDataEditable(
                this.props.data,
                this.handleEditRow,
                this.handleDeleteRow,
                this.props.payPeriod,
                this.props.filterDate,
              )}
              isFetchingData={this.props.isFetchingData}
              displayNumOfItemsFound={false}
              actions={actions}
              headerText="Clock In / Out"
              cardStyle
              wrapperStyle={{ flex: 1 }}
            />
      );
    };
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
        {this.props.isEditable && this.addDialogBox()}
        {this.props.isEditable && this.deleteDialogBox()}
        {this.props.isEditable && this.editDialogBox()}
        {this.props.isEditable ? editableCardWithoutClockInButton() : cardWithClockInButton()}
      </div>
    );
  }
}

ClockInOutCard.propTypes = {
  activeClock: PropTypes.object,
  displayClockInOutButton: PropTypes.bool,
  data: PropTypes.array.isRequired,
  isFetchingData: PropTypes.bool.isRequired,
  payPeriod: PropTypes.object.isRequired,
  getData: PropTypes.func.isRequired,
  getActiveClock: PropTypes.func,
  isFetchingActiveClock: PropTypes.bool,
  clockIn: PropTypes.func,
  clockOut: PropTypes.func,
  updatingUser: PropTypes.bool,
  filterDate: PropTypes.instanceOf(Date),

  // only if editable...
  isEditable: PropTypes.bool,
  addTimeClock: PropTypes.func,
  internetUserId: PropTypes.number,
  isAddingTimeClock: PropTypes.bool,
  isDeletingTimeClock: PropTypes.bool,
  isUpdatingTimeClock: PropTypes.bool,
  deleteTimeClock: PropTypes.func,
  updateTimeClock: PropTypes.func,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  refreshSummaryCard: PropTypes.func,
};

ClockInOutCard.defaultProps = {
  internetUserId: 0,
};

export default ClockInOutCard;
